module.exports = __webpack_public_path__ + "img/verification2.c718447c.png";